/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState } from 'react';
import {
	Button, Input, Form, Divider,
	Card,
} from 'antd-mobile';
import { Typography } from 'antd';

// import './login-form.scoped.css';
import { APP_CONFIG, isElectronApp } from '../../config';
import { FormType } from '../types';

interface LoginFormValues {
	email: string
	password: string
	quizCode: string
}

interface LoginFormProps {
	onLogin: (email: string, password: string, quizCode: string) => Promise<void>
	forgotPassword: () => void,
	openRegisterForm?: () => void,
	currentFormType: string,
}

export const LoginForm: React.FunctionComponent<LoginFormProps> = (props) => {
	const {
		onLogin: loginUser, forgotPassword, openRegisterForm, currentFormType,
	} = props;

	const [loggingIn, setLoggingIn] = useState<boolean>(false);
	const inputStyle = {
		border: 'none',
		borderBottom: '1px solid #d9d9d9',
		borderRadius: 0,
	};

	const handleLoginFormSubmit = useCallback(async (values: LoginFormValues) => {
		try {
			setLoggingIn(true);
			await loginUser(values.email.toLowerCase(), values.password, values.quizCode);
		} catch (e) {
			setLoggingIn(false);
		}
	}, [loginUser]);

	return (

		<Card style={{ border: '1px solid #ccc' }} title={currentFormType === FormType.Login ? 'Sign in' : 'Sign up'} headerStyle={{ border: 'none' }}>
			<Form
				onFinish={handleLoginFormSubmit}
				layout="vertical"
				style={{
					'--border-top': 'none',
					'--border-inner': 'none',
					'--border-bottom': 'none',
				}}
				footer={(
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
						<Button
							color="primary"
							size="large"
							type="submit"
							loading={loggingIn}
							style={{ width: '100%' }}
						>
							sign in
						</Button>
						{!isElectronApp && (
							<div style={{ margin: '0.5rem 0px -1rem' }}>
								<Button onClick={forgotPassword} fill="none" color="primary">forgot password?</Button>
							</div>
						)}
						{openRegisterForm && (
							<>
								<Divider style={{ marginTop: '10px' }}>
									<Typography.Text type="secondary">
										or
									</Typography.Text>
								</Divider>
								<Button
									color="default"
									size="large"
									type="button"
									onClick={openRegisterForm}
									style={{
										width: '100%',
										borderRadius: '5px',
									}}
								>
									sign up
								</Button>
							</>
						)}
					</div>
				)}
			>
				{APP_CONFIG.isChitkara ? (
					<Form.Item
						label="email or rollnumber *"
						name="email"
						rules={[{
							required: true, whitespace: true, message: 'Please enter email or roll number!',
						}, {
							type: 'string', message: 'Please enter valid email or roll number',
						}]}
						normalize={(value, prevVal, prevVals) => value.trim()}
					>
						<Input style={inputStyle} />
					</Form.Item>
				)
					: (
						<Form.Item
							label="email *"
							name="email"
							rules={[{
								required: true, whitespace: true, message: 'Please enter email!',
							}, {
								type: 'email', message: 'Please enter valid email',
							}]}
							normalize={(value, prevVal, prevVals) => value.trim()}
						>
							<Input type="email" style={inputStyle} />
						</Form.Item>
					)}

				<Form.Item
					label="password *"
					name="password"
					rules={[
						{ required: true, whitespace: true, message: 'Please enter password!' },
						{ min: 8, max: 32, message: 'Your password must be at least 8 characters and max, 32 characters long.' },
					]}
				>
					<Input type="password" style={inputStyle} />
				</Form.Item>

				<Form.Item
					label="test code *"
					name="quizCode"
					rules={[{ required: true, whitespace: true, message: 'Please enter the test code!' },
					{
						pattern: new RegExp(/^\d+$/),
						message: 'Please enter only numeric values',
					}]}
				>
					<Input type="text" style={inputStyle} />
				</Form.Item>
				<Form.Item><></></Form.Item>

			</Form>
		</Card>
	);
};
